<!-- Temporary component to flip between the current survey form and the new multi-step survey -->
<template>
  <div>
    <SurveyMultiStep v-if="experience === 'multi_step'" :recipientToken="recipientToken" />
    <SurveyForm v-if="experience === 'form'" :recipient_token="recipientToken" />
  </div>
</template>
<script>
import { getSurveyExperience } from '@/survey/api.js'
import SurveyForm from '@/survey/pages/SurveyForm.vue'
import SurveyMultiStep from '@/survey/pages/SurveyMultiStep.vue'

export default {
  components: {
    SurveyForm,
    SurveyMultiStep,
  },
  props: {
    recipientToken: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      experience: null,
    }
  },
  created() {
    getSurveyExperience(this.recipientToken).then((response) => {
      this.experience = response.data.experience
    })
  },
}
</script>
